import { getUrl, Request } from "../../request";

export const getUserCars = () => {
  return Request.get(getUrl("/api/v1/cars/user-car/"));
};

export const deleteUserCar = (id) => {
  return Request.del(getUrl(`/api/v1/cars/user-car/${id}/`));
};

export const getCarsBrands = (type) => {
  return Request.get(getUrl("/api/v1/cars/load_cars_brand/"), {
    type,
  });
};

export const getCarsModels = (brand_id) => {
  return Request.get(getUrl("/api/v1/cars/load_cars/"), {
    brand_id,
  });
};

export const postUserCar = (car_id, year) => {
  return Request.post(getUrl("/api/v1/cars/user-car/"), {
    car_id,
    year,
  });
};

export const putUserCar = (id, car_id, year) => {
  return Request.put(getUrl(`/api/v1/cars/user-car/${id}/`), {
    car_id,
    year,
  });
};
